var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table is-bordered data-table"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(column){return _c('th',{class:_vm.sortKey === column.name
                        ? _vm.sortOrders[column.name] > 0
                            ? 'sorting_asc'
                            : 'sorting_desc'
                        : 'sorting',style:('width:' + column.width + ';' + 'cursor:pointer;')},[_vm._v("\n                "+_vm._s(column.label)+"\n                "),_c('i',{staticClass:"far fa-check-circle"})])}),0)]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }